import script from "./UserNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNotifications.vue?vue&type=script&setup=true&lang=js"

import "./UserNotifications.vue?vue&type=style&index=0&id=75795946&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75795946"]])

export default __exports__